import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const SNDbRestore = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const onInputChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (!value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "File Name is required!" }));
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <p className="text-sm font-medium">Enter Restore Parameters</p>
            <div>
                <InputField
                    label="File Name"
                    name="fileName"
                    value={scheduledtasks?.fileName ?? ""}
                    required
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter file name"
                />
            </div>
        </div>
    );
};